module.exports = __webpack_public_path__ + "static/media/leque.0bb9b4dd.png";